import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LinkedCameraIcon(props: IconProps) {
    return <Icon {...props} iconKey={"linked_camera"}/>
}
